import { render, staticRenderFns } from "./DogList.vue?vue&type=template&id=400c7ca4"
import script from "./DogList.vue?vue&type=script&lang=ts"
export * from "./DogList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports